import { useCallback, useEffect, useState } from "react";
import FilterReports from "./FilterReports";
import Table from "rc-table";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { downloadXLSFile, get_reports } from "../../api/api";
import { separate } from "../PaymentHistory";
import InfiniteScroll from "react-infinite-scroller";
import Loading from "../Loading";
import { TbFileDownload } from "react-icons/tb";
import axios from 'axios';
import ComparisonChart from "./ComparisonChart";


const columns1 = [
    {
        title: 'ردیف',
        dataIndex: 'id',
        key: 'id',
        width: 0
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        key: 'title',
        width: 300
    },
    {
        title: 'ترافیک کلی',
        dataIndex: 'totalTraffic',
        key: 'totalTraffic',
        width: 20
    },
    {
        title: 'تعداد فروش',
        dataIndex: 'totalSaleCount',
        key: 'totalSaleCount',
        width: 30
    },
    {
        title: 'درآمد (ریال)',
        dataIndex: 'totalIncome',
        key: 'totalIncome',
        width: 50
    }
]
const columns2 = [
    {
        title: 'ردیف',
        dataIndex: 'id',
        key: 'id',
        width: 1
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        key: 'title',
        width: 100
    },
]

const Reports = () => {

    const [showDetails, setShowDetails] = useState(true)
    const [columns, setColumns] = useState(columns1)
    const [isLoading, setLoading] = useState(false)
    const [notFound, setNotFound] = useState(false)
    const [item, setItem] = useState([])
    const [isError, setIsError] = useState(false)
    const [fetching, setFetching] = useState(false)
    const [pageNum, setPageNum] = useState(1)
    const [itemCounter, setItemCounter] = useState(1)

    const [dataChart, setDataChart] = useState()

    const location = useLocation()
    const params = useParams()
    const [searchParams] = useSearchParams();


    useEffect(() => {
        setItem([])
        setNotFound(false)
        setPageNum(1)
        setLoading(true)
        setItemCounter(1)
    }, [params, searchParams])


    useEffect(() => {
        if (!showDetails) {
            setColumns(columns2)
        } else {
            setColumns(columns1)
        }
    }, [showDetails])


    //loadmore
    const fetchItems = useCallback(
        async () => {
            if (fetching || isError) {
                return;
            }

            setFetching(true);

            try {
                setLoading(true)
                const res = await axios.get(get_reports(pageNum, 20, location.search))
                res.data != '' ? setPageNum(pageNum + 1) : setPageNum(null)
                res.data == '' && pageNum === 1 ? setNotFound(true) : setNotFound(false)

                if (res.data) {
                    let counter = itemCounter
                    for (let index = 0; index < res.data?.length; index++) {

                        const element = res.data[index]
                        setItemCounter(itemCounter + (index + 1))

                        setItem(s => {
                            return [
                                ...s,
                                {
                                    key: counter,
                                    id: counter++,
                                    title: element.title,
                                    totalIncome: separate(element.totalIncome),
                                    totalSaleCount: separate(element.totalSaleCount),
                                    totalTraffic: separate(element.totalTraffic),
                                }
                            ]
                        })

                        //export Button
                        if (res.data.length === index + 1) {
                            setItem(s => {
                                return [
                                    ...s,
                                    {
                                        key: `exportFile-${counter * 65845684}`,
                                        id: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="30px" height="30px" fill="#107c41"><path d="M 28.8125 0.03125 L 0.8125 5.34375 C 0.339844 5.433594 0 5.863281 0 6.34375 L 0 43.65625 C 0 44.136719 0.339844 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 28.875 49.980469 28.9375 50 29 50 C 29.230469 50 29.445313 49.929688 29.625 49.78125 C 29.855469 49.589844 30 49.296875 30 49 L 30 1 C 30 0.703125 29.855469 0.410156 29.625 0.21875 C 29.394531 0.0273438 29.105469 -0.0234375 28.8125 0.03125 Z M 32 6 L 32 13 L 34 13 L 34 15 L 32 15 L 32 20 L 34 20 L 34 22 L 32 22 L 32 27 L 34 27 L 34 29 L 32 29 L 32 35 L 34 35 L 34 37 L 32 37 L 32 44 L 47 44 C 48.101563 44 49 43.101563 49 42 L 49 8 C 49 6.898438 48.101563 6 47 6 Z M 36 13 L 44 13 L 44 15 L 36 15 Z M 6.6875 15.6875 L 11.8125 15.6875 L 14.5 21.28125 C 14.710938 21.722656 14.898438 22.265625 15.0625 22.875 L 15.09375 22.875 C 15.199219 22.511719 15.402344 21.941406 15.6875 21.21875 L 18.65625 15.6875 L 23.34375 15.6875 L 17.75 24.9375 L 23.5 34.375 L 18.53125 34.375 L 15.28125 28.28125 C 15.160156 28.054688 15.035156 27.636719 14.90625 27.03125 L 14.875 27.03125 C 14.8125 27.316406 14.664063 27.761719 14.4375 28.34375 L 11.1875 34.375 L 6.1875 34.375 L 12.15625 25.03125 Z M 36 20 L 44 20 L 44 22 L 36 22 Z M 36 27 L 44 27 L 44 29 L 36 29 Z M 36 35 L 44 35 L 44 37 L 36 37 Z"></path></svg>,
                                        title: `دریافت خروجی اکسل از ردیف ${(counter - res.data.length) > 0 ? counter - res.data.length : counter - res.data.length + 1} تا  ${counter - 1}`,
                                        totalIncome: <><button onClick={() => handleExportExcelFile(pageNum)} className="btnExport"><TbFileDownload /> دریافت خروجی</button></>
                                    }
                                ]
                            })
                        }
                        ///

                    }
                }

            } catch (err) {
                setIsError(true)
            } finally {
                setFetching(false)
                setLoading(false)
            }

        },


        [item, fetching, pageNum]
    );

    const hasMoreItems = !!pageNum;
    //loadmore    


    const handleExportExcelFile = async (pageID) => downloadXLSFile(get_reports(pageID, 20, location.search, true))

    return (<>
        <div className="orders">
            <FilterReports showDetails={setShowDetails} setDataChart={setDataChart} />
            <div style={{ marginTop: 25 }}>
                <div className='row'>
                    <div id="topTitle"></div>
                    <div className='col-md-12'>


                        <div className='box_radios'>

                            <div className='chartHolder'>

                                {dataChart && <div id="theChart">
                                    <Loading styles='mini' />
                                    <ComparisonChart data={dataChart} />
                                </div>}

                                <div className="theTable">
                                    <InfiniteScroll
                                        loadMore={fetchItems}
                                        hasMore={hasMoreItems}
                                        loader={<Loading key={pageNum} styles={'mini'} />}
                                    >
                                        <Table columns={columns} data={item} tableLayout='auto' emptyText="" />
                                    </InfiniteScroll>
                                </div>

                            </div>

                            {notFound ? (<p className="theTable" style={{ textAlign: 'center' }}>هیچ داده ای برای نمایش وجود ندارد!</p>) : ''}


                        </div>


                    </div>
                    <div id="bottomTitle"></div>
                </div>
            </div>
        </div>
    </>);
}

export default Reports;